import { useRef } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { CareCreditChip } from '@frontend/payments-care-credit';
import { Text } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEP_LABELS, PAYMENT_MULTI_STEPS } from '../../../utils/steps';
import { StyledStep } from '../../atoms/styled-step';
import type { CareCreditEnrollDisclosureBodyProps } from './care-credit-enroll-disclosure.types';

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xs);
  `,
};

export const CareCreditEnrollDisclosureBody = ({ onGoBack, onCompleteStep }: CareCreditEnrollDisclosureBodyProps) => {
  const { t } = useTranslation();

  const { careCreditData } = useCollectPaymentMultiContext();

  const applicantStatus = careCreditData?.status;

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <StyledStep
      id={PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure}
      label={PAYMENT_MULTI_STEP_LABELS[PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure]}
      isValid={true}
      footer={{
        showBackButton: true,
        primary: {
          label: t('Check Now'),
        },
        onClickBack: onGoBack,
        onClickPrimary: onCompleteStep,
      }}
    >
      <div css={styles.content}>
        <div ref={containerRef}>
          <CareCreditChip status={applicantStatus} containerRef={containerRef} isResponsive />
        </div>
        <div>
          <Text>
            {t(
              'Check to see if this customer qualifies for CareCredit financing, either by completing a form in person or sending customer a secure link.  Customer can pay balance after they complete approval.'
            )}
          </Text>
        </div>
      </div>
    </StyledStep>
  );
};
